module.exports = __webpack_public_path__ + "static/img/灰底.c6a85eaf.png";